import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Absolute, Box, Link, Relative } from 'pcln-design-system';
import { CircleLarge, CircleLargeDarker, PricelineSidewaysP, PricelineSidewaysPDarker } from '../svg-build';
import { ImageContainer } from './ImageContainer';
/** @public */
export const Stage = /*#__PURE__*/styled(Relative).attrs({
  minHeight: ['268px', null, null, '330px', '576px']
}).withConfig({
  displayName: "Silhouette__Stage",
  componentId: "sc-1dz4qg3-0"
})(["overflow-y:clip;", "{overflow-y:unset;}"], themeGet('mediaQueries.xl'));
/** @public */
export const YellowOrb = /*#__PURE__*/styled(Box).attrs({
  size: '200px'
}).withConfig({
  displayName: "Silhouette__YellowOrb",
  componentId: "sc-1dz4qg3-1"
})(["position:absolute;bottom:0;left:0;"]);
/** @public */
export const StyledP = /*#__PURE__*/styled(props => React.createElement(PricelineSidewaysP, {
  ...props
})).withConfig({
  displayName: "Silhouette__StyledP",
  componentId: "sc-1dz4qg3-2"
})(["", " &,& > svg{width:100%;height:100%;}"], ({
  mirror
}) => mirror === 'left' ? 'transform: scaleX(-1);' : '');
/** @public */
export const StyledPDarker = /*#__PURE__*/styled(props => React.createElement(PricelineSidewaysPDarker, {
  ...props
})).withConfig({
  displayName: "Silhouette__StyledPDarker",
  componentId: "sc-1dz4qg3-3"
})(["", " &,& > svg{width:100%;height:100%;}"], ({
  mirror
}) => mirror === 'left' ? 'transform: scaleX(-1);' : '');
/** @public */
export const StyledCircleLargeDarker = /*#__PURE__*/styled(CircleLargeDarker).withConfig({
  displayName: "Silhouette__StyledCircleLargeDarker",
  componentId: "sc-1dz4qg3-4"
})(["&,& > svg{width:100%;height:100%;}"]);
/** @public */
export const StyledCircleLarge = /*#__PURE__*/styled(CircleLarge).withConfig({
  displayName: "Silhouette__StyledCircleLarge",
  componentId: "sc-1dz4qg3-5"
})(["&,& > svg{width:100%;height:100%;}"]);
/** @public */
export const CircleStage = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Silhouette__CircleStage",
  componentId: "sc-1dz4qg3-6"
})(["z-index:3;", "{z-index:1;}"], themeGet('mediaQueries.lg'));
/** @public */
export const PStage = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Silhouette__PStage",
  componentId: "sc-1dz4qg3-7"
})(["z-index:2;"]);
/** @public */
const Silhouette = ({
  mirror,
  imageUrl,
  className,
  imageClassName,
  handleImageClick,
  ariaLabel,
  isDarkerFill
}) => {
  const SPHERE_OFFSET = ['-30%', '-20%', null, null, '-70%', '-45%'];
  const sphereProps = mirror === 'left' ? {
    left: SPHERE_OFFSET
  } : {
    right: SPHERE_OFFSET
  };
  const P_OFFSET = ['-45%', null, '-28%', '-35%', '-15%', '-20%'];
  const pProps = mirror === 'left' ? {
    right: P_OFFSET,
    transform: 'scaleX(-1)'
  } : {
    left: P_OFFSET
  };
  return React.createElement(Stage, {
    className: className
  }, React.createElement(CircleStage, {
    width: ['340px', null, '458px', null, '576px'],
    bottom: '0',
    ...sphereProps
  }, isDarkerFill ? React.createElement(Box, {
    "data-testid": 'darker-svg-large-circle'
  }, React.createElement(StyledCircleLargeDarker, null), ' ') : React.createElement(Box, {
    "data-testid": 'lighter-svg-large-circle'
  }, React.createElement(StyledCircleLarge, null))), React.createElement(PStage, {
    width: ['412px', null, null, '640px', '115%'],
    top: ['-70%', null, '-75%', '-100%', '-60%', '-70%'],
    ...pProps
  }, isDarkerFill ? React.createElement(Box, {
    "data-testid": 'darker-svg-priceline-p'
  }, React.createElement(StyledPDarker, {
    mirror: mirror
  }), ' ') : React.createElement(Box, {
    "data-testid": 'lighter-svg-priceline-p'
  }, React.createElement(StyledP, {
    mirror: mirror
  }))), handleImageClick ? React.createElement(Link, {
    target: '_blank',
    onClick: handleImageClick,
    "data-testid": 'silhouette-img',
    "aria-label": ariaLabel
  }, React.createElement(ImageContainer, {
    mirror: mirror,
    imageUrl: imageUrl,
    imageClassName: imageClassName
  })) : React.createElement(ImageContainer, {
    mirror: mirror,
    imageUrl: imageUrl,
    imageClassName: imageClassName
  }));
};
Silhouette.defaultProps = {
  mirror: 'right',
  isDarkerFill: false
};
/** @public */
export { Silhouette };